const r = "-ariaError";
export {
  r as ARIA_ERROR_SUFFIX
};
